module.exports = __webpack_public_path__ + "static/media/publicsonar_publicsafety_default.cc3bfb31.svg";